import React from 'react';

const Project = ({ slide, index, slidesLiegth }) => {
  return (
    <div className={`h-screen swiper-${index + 1} relative`}>
      <div className="h-full">
        <img
          className="w-full h-full fit-image"
          src={slide.logo}
          alt={slide.alt}
          width={2200}
          height={1253}
          loading={index === 0 ? 'eager' : 'lazy'}
          decoding="async"
        />
      </div>
      <div className="project__scrim absolute w-full h-full" />
      <div className="project__heading w-full absolute">
        <p className="text-[13px] md:text-[17px] mb-2 display-block project__heading-title fw-600">
          PROJECT {index + 1} / {slidesLiegth}
        </p>
        <div className="project__heading-separator" />
      </div>
      <div className="project__description absolute w-[85%] sm:w-[70%] md:w-60">
        <h1 className="text-[26px] sm:text-[34px] md:text-[43px] fw-600 mb-2">{slide.title}</h1>
        <p className="text-[13px] md:text-[14px] mb-4">{slide.description}</p>
        <a className="fs-12" href={slide.nextPage} target="_blank" rel="noreferrer">
          VISIT SITE
        </a>
      </div>
    </div>
  );
};

export default Project;
